export class SnapHandler {
    private snappedAttribute: string = "snapped";
    private snapAreaSelector: string = ".snap-area";
    
    public SnapToElement(snapToElement: HTMLElement, snapElement: HTMLElement): void {
        let snapArea: HTMLElement = snapToElement;
        const snapAreaList = snapToElement.querySelectorAll(this.snapAreaSelector);
        if(snapAreaList.length > 0) { snapArea = snapAreaList[0] as HTMLElement; }
        
        this.CleanUpSnappedElements();

        snapArea.setAttribute(this.snappedAttribute, "true");
        snapArea.innerHTML = snapElement.innerHTML;
    }
    
    public CleanUpSnappedElements(): void {
        document.querySelectorAll("["+this.snappedAttribute+"]").forEach((snapElement: Element) => {
            snapElement.innerHTML = '';
            snapElement.removeAttribute(this.snappedAttribute);
        });
    }
}